import { createSetRentalsDataAction } from "../actions/dataActions";
import { useGetAndSet } from "./useGetAndSet";

export const useRentalsData = (params, dataFresh) => {
  return useGetAndSet("rentals", params, createSetRentalsDataAction, dataFresh);
};
